import Emitter from "es6-event-emitter";
import template from "./../templates/sharingLandingBanner.dust";

// eslint-disable-next-line no-unused-vars
import language from "./../dictionary";

/**
 * @typedef {object} SharingLandingBannerComponentOptions
 * @property {HTMLElement | null | undefined} DOMContainer
 * @property {string | undefined} signupLink
 */

export default class SharingLandingBannerComponent extends Emitter {
  /**
   * @type {string | undefined}
   */
  signupLink;
  /**
   * @type {HTMLElement | null | undefined}
   */
  DOMContainer;
  /**
   * @type {HTMLElement | null}
   */
  banner;
  /**
   * @type {HTMLElement | null}
   */
  loginButton;
  /**
   * @type {HTMLElement | null}
   */
  closeButton;

  /**
   * @param {HTMLElement} DOMContainer
   * @param {SharingLandingBannerComponentOptions} props
   */
  constructor(props) {
    super();
    this.signupLink = props.signupLink;
    this.DOMContainer = props.DOMContainer;
    this.render();
  }

  render() {
    const context = {
      text: language.sharingLandingBanner.text,
      signup: language.sharingLandingBanner.signup,
      signupLink: this.signupLink,
      login: language.sharingLandingBanner.login,
    };
    Dust.render(template, context, (err, result) => {
      if (err) {
        // eslint-disable-next-line no-console
        console.error(
          "Error while rendering SharingLandingBannerComponent:",
          err
        );
        return;
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(result, "text/html");

      if (!this.DOMContainer) {
        return;
      }
      this.DOMContainer.appendChild(doc.body.firstChild);

      this.banner = this.DOMContainer.querySelector(".sharing-landing-banner");
      this.loginButton = this.DOMContainer.querySelector(
        ".sharing-landing-banner-button-login"
      );
      this.closeButton = this.DOMContainer.querySelector(
        ".sharing-landing-banner-close"
      );

      this._addEventListeners();
    });
  }

  _addEventListeners() {
    this._getButtonsWithHandlers().forEach(({ element, handler }) => {
      if (element) {
        element.addEventListener("click", handler);
      }
    });
  }

  _removeEventListeners() {
    this._getButtonsWithHandlers().forEach(({ element, handler }) => {
      if (element) {
        element.removeEventListener("click", handler);
      }
    });
  }

  /**
   * @returns {Array<{element: HTMLElement | undefined, handler: Function}>}
   */
  _getButtonsWithHandlers() {
    // handlers are bound such that the same function reference is used for both
    // adding and removing event listeners
    const result = [];

    if (this.closeButton) {
      result.push({
        element: this.closeButton,
        handler: this._onCloseButtonClick.bind(this),
      });
    }

    if (this.loginButton) {
      result.push({
        element: this.loginButton,
        handler: this._onLoginButtonClicked.bind(this),
      });
    }

    return result;
  }

  /**
   * @param {MouseEvent} e
   */
  _onCloseButtonClick(e) {
    e.stopPropagation();
    this.destroy();
  }

  /**
   * @param {MouseEvent} e
   */
  _onLoginButtonClicked(e) {
    e.stopPropagation();
    this.trigger("sharingLandingBanner:loginButtonClicked");
  }

  destroy() {
    if (!this.banner) {
      return;
    }
    this.banner.remove();
    this.banner = undefined;
    this.closeButton = undefined;
    this._removeEventListeners();
  }
}



// WEBPACK FOOTER //
// ./src/common/components/sharingLandingBannerComponent.js